var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_8266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7308 10.1566C14.2006 9.69067 13.5575 9.28809 12.8193 8.96008C12.5038 8.81995 12.1345 8.96204 11.9944 9.27747C11.8542 9.5929 11.9963 9.96216 12.3118 10.1024C12.9342 10.379 13.4706 10.7131 13.9058 11.0956C14.4423 11.567 14.75 12.2496 14.75 12.9688V14.125C14.75 14.4696 14.4696 14.75 14.125 14.75H1.875C1.5304 14.75 1.25 14.4696 1.25 14.125V12.9688C1.25 12.2496 1.55774 11.567 2.09424 11.0956C2.72571 10.5406 4.56555 9.25 8 9.25C10.5502 9.25 12.625 7.17517 12.625 4.625C12.625 2.07483 10.5502 0 8 0C5.44983 0 3.375 2.07483 3.375 4.625C3.375 6.11584 4.08423 7.44397 5.18286 8.29028C3.17261 8.73218 1.92212 9.58276 1.26917 10.1566C0.462646 10.8652 0 11.8901 0 12.9688V14.125C0 15.1589 0.841064 16 1.875 16H14.125C15.1589 16 16 15.1589 16 14.125V12.9688C16 11.8901 15.5374 10.8652 14.7308 10.1566ZM4.625 4.625C4.625 2.76404 6.13904 1.25 8 1.25C9.86096 1.25 11.375 2.76404 11.375 4.625C11.375 6.48596 9.86096 8 8 8C6.13904 8 4.625 6.48596 4.625 4.625Z",
    fill: "#3F4752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_8266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.3f3caa9120e111343259eaa72e01ffce.svg";
export { ForwardRef as ReactComponent };